export const SLOT_TIME_MINUTES = 20;
export const NUMBER_OF_SLOTS = (24 * 60) / SLOT_TIME_MINUTES;
export const NUMBER_OF_SLOTS_PER_HOUR = 60 / SLOT_TIME_MINUTES;
